module.exports = __webpack_public_path__ + "static/media/cam.397bd40e.png";